var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { INVALID_VATID_ERROR, INVALID_GSTIN_ERROR, WEBAPP_RPC_STATIC_WEBSITE_DOMAIN, DOMAIN_MAP, REMOTEDESKTOP_PRODUCT_CODE, MEETING_PRODUCT_CODE, WEBAPP_REMOTE_DESKTOP_WEBSITE_DOMAIN, WEBAPP_WEBSITE_DOMAIN } from "./constants";
import { MakePOSTRequest } from "./RestClient";
export function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
    }
    else {
        var textArea_1 = document.createElement("textarea");
        textArea_1.value = text;
        textArea_1.style.position = "absolute";
        textArea_1.style.opacity = '0';
        document.body.appendChild(textArea_1);
        textArea_1.select();
        return new Promise(function (res, rej) {
            document.execCommand('copy') ? res('copied') : rej('exec command error');
            textArea_1.remove();
        });
    }
}
/**
 * accepts number only while entering input via keyboard
 */
export function isNumber(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return false;
    }
    return true;
}
/**
 * validates input entered by pasting and accepts numbers only
 */
export function nonNumberCheckOnPaste(evt) {
    var ctrlDown = evt.ctrlKey || evt.metaKey;
    var initialValue = evt.currentTarget.value;
    var element = evt.currentTarget;
    if (ctrlDown && evt.keyCode == 86) {
        setTimeout(function () {
            if (isNaN(parseInt(element.value)))
                element.value = initialValue;
        }, 10);
    }
}
export function isValidCompName(name) {
    var valid = true, errMsg = '';
    var filter = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    var emoji = false;
    if (filter.test(name)) {
        emoji = true;
    }
    else {
        emoji = false;
    }
    if (name.trim().length === 0) {
        errMsg = "Computer name cannot be blank";
        valid = false;
    }
    else if (emoji) {
        valid = false;
        errMsg = "Emoji's are not allowed";
    }
    else {
        var filter_1 = /^[a-zA-Z0-9_\-'\s]{1,50}$/;
        if (!filter_1.test(name)) {
            valid = false;
            errMsg = localized_messages["rename.computer.invalidchar"];
        }
    }
    return {
        valid: valid,
        errMsg: errMsg
    };
}
//fading outside part of sidebar
export function fadeOutsideSidebar() {
    var node = document.createElement("div");
    node.className = "rpc-sidebar-fade active";
    document.body.prepend(node);
}
export function showCommonSuccessHtml(displayHtml) {
    $('#notify_succ').show().find('#commonSuccesMsg').html(displayHtml).show();
    setTimeout(function () { $('#notify_succ').fadeOut(); }, 5000);
}
export function showCommonSuccessHtmlOnTop(displayHtml) {
    var node1 = document.createElement("div");
    node1.className = "successms";
    node1.id = "notify_succ_body";
    node1.innerHTML = "<span class='successCls'></span><p>" + displayHtml + "</p>";
    document.body.append(node1);
    setTimeout(function () { $('#notify_succ_body').remove(); }, 5000);
}
export function sortGroupAdmins(groupAdminsList) {
    var newList = __spreadArray([], groupAdminsList, true);
    newList.sort(function (a, b) { return ("".concat(a.firstname, " ").concat(a.lastname).toLowerCase() > "".concat(b.firstname, " ").concat(b.lastname).toLowerCase()) ? 1 : (("".concat(b.firstname, " ").concat(b.lastname).toLowerCase() > "".concat(a.firstname, " ").concat(a.lastname).toLowerCase()) ? -1 : 0); });
    return newList;
}
/**
 *
 * @param DateString "2022-12-31 13:30:00.0" format date
 * @returns "12/31/2022 13:30:00 GMT" format date
 */
export function convertToAllBrowserDateFormat(DateString) {
    var date = DateString.split(" ")[0];
    var _a = date.split('-'), year = _a[0], month = _a[1], day = _a[2];
    date = [month, day, year].join('/');
    var time = DateString.split(" ")[1].substring(0, 8);
    return new Date("".concat(date, " ").concat(time, " GMT"));
}
export function showRateLimitToastMessage() {
    var webAppDomainSupportLink = isRdpAccount(productCode) ? WEBAPP_REMOTE_DESKTOP_WEBSITE_DOMAIN + "/remote-desktop-support" : WEBAPP_WEBSITE_DOMAIN + "/support";
    showCommonErrMsg("<span>You have exceeded the number of attempts. Retry after " + rateLimitDuration + " minutes. <a class='blue-clr' target='_blank' rel='noopener noreferrer' href='" + webAppDomainSupportLink + "'>Contact support</a> for further assistance.</span>");
}
export function showRateLimitToastMessage24Hours() {
    var webAppDomainSupportLink = isRdpAccount(productCode) ? WEBAPP_REMOTE_DESKTOP_WEBSITE_DOMAIN + "/remote-desktop-support" : WEBAPP_WEBSITE_DOMAIN + "/support";
    showCommonErrMsg("<span>You have exceeded the number of attempts. Retry after " + Math.floor(rateLimitDuration24Hours / 60) + " hours. <a class='blue-clr' target='_blank' rel='noopener noreferrer' href='" + webAppDomainSupportLink + "'>Contact support</a> for further assistance.</span>");
}
export function showRateLimitToastMessageForUpgrade() {
    var webAppDomainSupportLink = isRdpAccount(productCode) ? WEBAPP_REMOTE_DESKTOP_WEBSITE_DOMAIN + "/remote-desktop-support" : WEBAPP_WEBSITE_DOMAIN + "/support";
    showCommonErrMsg("<span>You have exceeded the number of attempts. Retry after " + Math.floor(rateLimitDurationForUpgrade / 60) + " hours. <a class='blue-clr' target='_blank' rel='noopener noreferrer' href='" + webAppDomainSupportLink + "'>Contact support</a> for further assistance.</span>");
}
export function checkEmailValidity(email) {
    var errorMsg = '', valid = true;
    if (email.length == 0) {
        // errorMsg = "Email address cannot be blank";
        // valid = false;
    }
    else if (!isValidEmail(email)) {
        errorMsg = localized_messages["valid.email.addr"];
        valid = false;
    }
    return { valid: valid, errorMsg: errorMsg };
}
export function hideTooltip() {
    var tooltip = document.getElementsByClassName("rpc_tooltip_body")[0];
    if (tooltip) {
        tooltip.style.display = "none";
        for (var i = 0; i < document.getElementsByClassName("rpc_tooltip_body").length; i++) {
            document.getElementsByClassName("rpc_tooltip_body")[i].style.display = "none";
        }
    }
}
export function validateTaxNumber(taxNumber, taxType, elementId, errId) {
    if (taxNumber != "") {
        var taxid_regex;
        if (taxType == "vat")
            taxid_regex = /^([a-zA-Z0-9]){8,20}$/;
        else
            taxid_regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        taxNumber = taxNumber.trim();
        if (!taxid_regex.test(taxNumber)) {
            document.getElementById('commonLoader').style.display = 'none';
            document.getElementById(elementId).focus();
            if (taxType == "vat")
                document.getElementById(errId).innerText = INVALID_VATID_ERROR;
            else
                document.getElementById(errId).innerText = INVALID_GSTIN_ERROR;
            document.getElementById(errId).style.display = 'block';
            setTimeout(function () {
                document.getElementById(errId).style.display = 'none';
            }, 5000);
            return false;
        }
    }
    return true;
}
export function isValidStateName(valStateName) {
    var filter = /[\\"]/;
    if (!(filter.test(valStateName))) {
        return true;
    }
    else {
        return false;
    }
}
export function detectOperatingSystem() {
    var userAgent = window.navigator.userAgent;
    var platform = window.navigator.platform;
    var os = null;
    // Detect Windows
    if (platform.indexOf('Win') !== -1) {
        os = 'Windows';
    }
    // Detect macOS
    else if (platform.indexOf('Mac') !== -1) {
        os = 'macOS';
    }
    // Detect Android (userAgent contains 'Android')
    else if (/Android/.test(userAgent)) {
        os = 'Android';
    }
    // Detect iOS (iPhone, iPad, etc.)
    else if (/iPhone|iPad|iPod/.test(userAgent)) {
        os = 'iOS';
    }
    // Detect Linux
    else if (platform.indexOf('Linux') !== -1) {
        os = 'Linux';
    }
    else {
        os = 'Unknown';
    }
    return os;
}
export function getTimeZoneOffsetString(time_zone, for_date) {
    if (time_zone == undefined) {
        time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    if (for_date == undefined || for_date == "") {
        for_date = new Date();
    }
    var dateWithTZ = Intl.DateTimeFormat("en-US", {
        timeZone: time_zone,
        // @ts-ignore
        timeZoneName: "longOffset"
    }).format(for_date);
    var newZoneStr = dateWithTZ === null || dateWithTZ === void 0 ? void 0 : dateWithTZ.split(",")[1].trim();
    return newZoneStr;
}
/**
 * Generate Readable date format.
 */
export function generateReadableDateFormat(timestamp, locale) {
    var parts = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    }).formatToParts(new Date(timestamp));
    var monthLiteral = '';
    try {
        var monthPartIndex = parts.findIndex(function (p) { return p.type === 'month'; });
        monthLiteral = parts[monthPartIndex + 1].value;
    }
    catch (error) { }
    return "".concat(parts.find(function (p) { return p.type === 'month'; }).value).concat(monthLiteral, " ").concat(parts.find(function (p) { return p.type === 'day'; }).value, " ").concat(parts.find(function (p) { return p.type === 'year'; }).value);
}
/**
 * YYYY-MM-DD to MM-DD-YYYY
 */
export function convertDateToMMDDYYYYFormat(date) {
    return "".concat(date.split("-")[1], "-").concat(date.split("-")[2], "-").concat(date.split("-")[0]);
}
/**
 * MM-DD-YYYY to DD/MM/YYYY
 */
export function convertDateToSlashFormat(date) {
    return "".concat(date.split("-")[1], "/").concat(date.split("-")[0], "/").concat(date.split("-")[2]);
}
/**
 * DD/MM/YYYY to YYYY-MM-DD
 */
export function convertDateToYYYYMMDDFormat(date) {
    return "".concat(date.split("/")[2], "-").concat(date.split("/")[1], "-").concat(date.split("/")[0]);
}
/**
 * YYYY-MM-DD to DD/MM/YYYY
 */
export function convertDateToDDMMYYYYFormat(date) {
    return "".concat(date.split("-")[2], "/").concat(date.split("-")[1], "/").concat(date.split("-")[0]);
}
/**
 *
 * @param len length of unique id
 * @returns return alphanumeric id
 */
export function generateUID(len) {
    var text = [];
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
        text.push(possible.charAt(Math.floor(Math.random() * possible.length)));
    return text.join("");
    ;
}
/**
 * for api failure case, use type `T_API_WEB_ACCESS_TOKEN_FAILURE` for handling errors
 * @returns
 */
export function getWebAccessToken() {
    return new Promise(function (resolve, reject) {
        MakePOSTRequest('getWebAccessToken', null, {})
            .then(function (_a) {
            var data = _a.data;
            var responseJSON = data;
            if (responseJSON.result != undefined && responseJSON.result === 'INVALID_SESSION') {
                reject('INVALID_SESSION');
                return;
            }
            else if (responseJSON.result != undefined && responseJSON.result === 'SUCCESS') {
                resolve(responseJSON);
                return;
            }
            else {
                reject("UNKNOWN_ERROR");
                return;
            }
        })
            .catch(function (error) {
            try {
                var statusCode = error.response.status;
                if (statusCode == 401) {
                    reject('INVALID_SESSION');
                    return;
                }
            }
            catch (e) { }
            reject("UNKNOWN_ERROR");
        });
    });
}
export var debounce = function (func, delay) {
    var timer;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(void 0, args);
        }, delay);
    };
};
export function getRedirectDomain(productCode, domainType) {
    //added for language redirection for static pages
    var lang = getCookieValue('lang');
    if (lang && lang !== 'en' && domainType === 'website') {
        return "".concat(DOMAIN_MAP[productCode][domainType], "/").concat(lang);
    }
    return DOMAIN_MAP[productCode][domainType];
}
export function isRdpAccount(productCode) {
    return productCode === REMOTEDESKTOP_PRODUCT_CODE;
}
export function isMeetingAccount(productCode) {
    return productCode === MEETING_PRODUCT_CODE;
}
export function getStaticWebsiteDomain(productCode) {
    return (productCode === REMOTEDESKTOP_PRODUCT_CODE) ? WEBAPP_REMOTE_DESKTOP_WEBSITE_DOMAIN : WEBAPP_RPC_STATIC_WEBSITE_DOMAIN;
}
export function isValidEmail(newEmail) {
    var filter = /^([\w-\.+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,25}|[0-9]{1,3})(\]?)$/;
    if (newEmail.length <= 80 && filter.test(newEmail)) {
        return true;
    }
    else {
        return false;
    }
}
;
export function get_browser_info() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'IE', version: (tem[1] || '') };
    }
    if (/Edge/.test(navigator.userAgent)) {
        tem = ua.match(/\bOPR|Edge\/(\d+)/);
        if (tem != null) {
            return { name: 'Edge', version: tem[1] };
        }
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/);
        if (tem != null) {
            return { name: 'Opera', version: tem[1] };
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return {
        name: M[0],
        version: M[1]
    };
}
export function firstLetterUpperCase(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 *
 * @param name cookie name
 * @returns cookie value
 */
export function getCookieValue(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
}
